import React from 'react';
import { Col, Container, Row } from 'reactstrap';
//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import CustomQuizType from './quizTable';

export default function QuizList() {
  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <Breadcrumbs
            title='Dictionary'
            breadcrumbItem='Quiz'
          />
          <Row>
            <Col className='col-12'>
              <CustomQuizType />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}
